<template>
  <div class="detail-content">
    <div id="aicourse" v-show="!loading">

        <!-- Tên khóa học -->
        <div class="primarylists list-mobile">
            <div class="titles clear">
                <img src="../../../static/images/icon-st.jpg"/>
                <div class="title l">{{ course.name }}</div>
            </div>
        </div>

        <!-- Tổng quan khóa học -->
        <div class="Aicourse_header mg-aicourse">
            <div class="Aicourse_header_black">
                <ul v-if="!course.isUrl">
                    <li class="Aicourse_header_inner">

                        <!-- Thông tin chi tiết -->
                        <p class="ArtificialIntelligence-figure_text" v-html="course.synopsis"></p>

                        <div class="Aicourse_table">
                            <ul>
                                <li>
                                    <p>{{ $t("aicourse.category") }} :&nbsp;</p>
                                    <p>{{ course.category }}</p>
                                </li>
                                <li>
                                    <p>{{ $t("new.title44") }} :&nbsp;</p>
                                    <p style="min-width: 120px">
                                        <span v-if="course.startDate != null || course.endDate != null">{{course.startDate ? course.startDate: $t("new.title45")}} ~ {{course.endDate ? course.endDate : $t("new.title45")}}</span>
                                        <span v-if="course.startDate == null && course.endDate == null">{{ $t("new.title45") }}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <!-- Btn: Xác nhận - Bắt đầu - Quay lại -->
                        <div class="three-btn" :class="[{'three-btn-mobile': mobile}]">

                            <!-- Xác nhận tiến độ -->
                            <button v-if="isTeacher" @click="progess({courseId: course.courseId, name: course.name, userId: userId})" class="btn-01">
                                {{ $t("new.title50") }}
                            </button>

                            <!-- Tham khảo nội dụng khoá học -->
                            <button v-if="isTeacher && checkFinalExam && isAccountTeacher && course.categoryCode != 15 && course.categoryCode != 14 && course.categoryCode != 13 && course.categoryCode != 16" @click="preview()" class="btn-01">
                                {{ $t("new.title240") }}
                            </button>

                            <!-- Bắt đầu khóa học -->
                            <template v-if="isLogin">
                                <button v-if="course.categoryCode != 15 && course.categoryCode != 14 && course.categoryCode != 13 && course.categoryCode != 16" @click="start()" class="btn-01">
                                    {{ $t("aicourse.beginLearn") }}
                                </button>

                            <!-- Bảng cam kết -->
                            <button v-if="course.categoryCode == 14 || course.categoryCode == 13" class="btn-01" @click="startBck({courseId: course.courseId, name: course.named})">
                                {{ $t("curriculum.covenant") }}
                            </button>

                            <!-- Bảng khảo sát -->
                            <button v-if="course.categoryCode == 15 || course.categoryCode == 13 || (course.categoryCode == 14 && course.externalLink != null && course.externalLink != '') || (course.categoryCode == 16 && course.externalLink != null && course.externalLink != '')" @click="startBks({courseId: course.courseId, name: course.named, categoryCode: course.categoryCode, externalLink: course.externalLink})" class="btn-01">
                                {{ $t("curriculum.question") }}
                            </button>

                            <!-- Hoàn thành -->
                                <button v-if="course.categoryCode == 15 || course.categoryCode == 14 || course.categoryCode == 13" @click="finished()" class="btn-01">
                                    {{ $t("aicourse.endLearn") }}
                                </button>
                            </template>

                            <!-- Btn: Quay lại -->
                            <button @click="back()" class="btn-01 btn-back">
                                <span>{{ $t("common.returnButton") }}</span>
                            </button>
                        </div>
                    </li>
                </ul>

                <!-- Type: Live stream -->
                <ul v-else>
                    <li class="Aicourse_header_inner">
                        <template>
                            <div v-if="course.isUrlFb" class="lkt-livestream" v-html="course.synopsis"></div>
                            <div v-else class="lkt-livestream" v-html="course.synopsis"></div>
                        </template>
                        <div class="three-btn" v-if="mobile" style="margin-top:0">
                            <button @click="back()" class="btn-01 btn-back">
                            <span>{{ $t("common.returnButton") }}</span>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Nội dung chi tiết khóa học -->
        <div class="Aicourse_list-1">
            <ul>
                <li v-if="course.title1 !== '' && course.title1 !== null">
                    <div class="div_img">
                        <img :src="course.imgPath1 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath1" alt="/" />
                    </div>
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title1 }}
                        </p>
                        <p v-if="course.content1" class="Aicourse_font_p-1" v-html="course.content1.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
                    </div>
                </li>
                <li v-if="course.title2 !== '' && course.title2 !== null">
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title2 }}
                        </p>
                        <p v-if="course.content2" class="Aicourse_font_p-1" v-html="course.content2.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
                    </div>
                    <div class="div_img">
                        <img :src="course.imgPath2 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath2" alt="/" />
                    </div>
                </li>
                <li v-if="course.title3 !== '' && course.title3 !== null">
                    <div class="div_img">
                        <img :src="course.imgPath3 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath3" alt="/" />
                    </div>
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title3 }}
                        </p>
                        <p v-if="course.content3" class="Aicourse_font_p-1" v-html="course.content3.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
                    </div>
                </li>
                <li v-if="course.title4 !== '' && course.title4 !== null">
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title4 }}
                        </p>
                        <p v-if="course.content4" class="Aicourse_font_p-1" v-html="course.content4.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
                    </div>
                    <div class="div_img">
                        <img :src="course.imgPath4 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath4" alt="/" />
                    </div>
                </li>
                <li v-if="course.title5 !== '' && course.title5 !== null">
                    <div class="div_img">
                        <img :src="course.imgPath5 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath5" alt="/" />
                    </div>
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title5 }}
                        </p>
                        <p v-if="course.content5" class="Aicourse_font_p-1" v-html="course.content5.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <!-- Loading -->
    <loading class="loading--lesson" :showLoading="loading" />

    <!-- Popup: Kết thúc khóa học -->
    <el-dialog custom-class="class1" style="padding: 0 20px;" :title="$t('new.title19')" :visible.sync="isShow" :modal="true" :width="setDialogWidth()" :center="true">
        <template v-if="curriculumInfo != null">
            <div style="vertical-align: middle; text-align: center;">
                <el-timeline style="display: inline-block; text-align: left;">
                    <el-timeline-item style="color: white;" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp1">
                        {{$t("new.title20")}}
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep2 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp2">
                        {{$t("new.title22")}}（{{curriculumInfo.ratio2}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep2 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp2">
                        {{$t("new.title22") }}（{{curriculumInfo.ratio2}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep2 == 0" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp2">
                        {{ $t("new.title22") }}（{{curriculumInfo.ratio2}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep3 == 1 && curriculumInfo.isExamShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp3">
                        {{ $t("curriculum.exam") }}（{{curriculumInfo.ratio3}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep3 == 2 && curriculumInfo.isExamShow == 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp3">
                        {{ $t("curriculum.exam") }}（{{curriculumInfo.ratio3}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep3 == 0 && curriculumInfo.isExamShow == 1" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp3">
                        {{ $t("curriculum.exam") }}（{{curriculumInfo.ratio3}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep5 == 1 && curriculumInfo.isCovenantShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp5">
                        {{ $t("curriculum.covenant") }}（{{curriculumInfo.ratio1}}）
                    </el-timeline-item>
                    <el-timeline-item v-if=" curriculumInfo.isShowStep5 == 2 && curriculumInfo.isCovenantShow == 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp5">
                        {{ $t("curriculum.covenant") }}（{{curriculumInfo.ratio1}}）
                    </el-timeline-item>
                    <el-timeline-item v-if=" curriculumInfo.isShowStep5 == 0 && curriculumInfo.isCovenantShow == 1" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp5">
                        {{ $t("curriculum.covenant") }}（{{curriculumInfo.ratio1}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep4 == 1 && curriculumInfo.isQuestionnaireShow == 1 && curriculumInfo.externalLink == null" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp4">
                        {{ $t("new.title33") }}（{{curriculumInfo.ratio4}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep4 == 2 && curriculumInfo.isQuestionnaireShow == 1 && curriculumInfo.externalLink == null" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp4">
                        {{ $t("new.title33") }}（{{curriculumInfo.ratio4}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep4 == 0 && curriculumInfo.isQuestionnaireShow == 1 && curriculumInfo.externalLink == null" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp4">
                        {{ $t("new.title33") }}（{{curriculumInfo.ratio4}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep6 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp6">
                        {{ $t("new.title21") }}（{{curriculumInfo.ratio5}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep6 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp6">
                        {{ $t("new.title21") }}（{{curriculumInfo.ratio5}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep6 == 0" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp6">
                        {{ $t("new.title21") }}（{{curriculumInfo.ratio5}}）
                    </el-timeline-item>
                </el-timeline>
            </div>
            <div v-if="(curriculumInfo.isShowStep1 != 1 || curriculumInfo.isShowStep2 != 1 || curriculumInfo.isShowStep3 != 1 || curriculumInfo.isShowStep4 != 1 || curriculumInfo.isShowStep5 != 1) && curriculumInfo.isFinished == 0">
                <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
            </div>
            <div v-if="curriculumInfo.isFinished == 1">
                <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
            </div>
            <div class="btn-finish-aircourse" v-if=" curriculumInfo.isShowStep1 == 1 && curriculumInfo.isShowStep2 == 1 && curriculumInfo.isShowStep3 == 1 && curriculumInfo.isShowStep4 == 1 && curriculumInfo.isShowStep5 == 1 && curriculumInfo.isFinished == 0">
                <div class="SubmitPaper_pn" @click="submitFinishCourse">
                    {{ $t("new.title34") }}
                </div>
            </div>
        </template>
    </el-dialog>
  </div>
</template>
<script>
    import { mapState } from "vuex";
    import loading from "@/components/loading/loading";

    export default {
        name: "Aicourse",
        data() {
            return {
                course: {},
                curriculumInfo: {},
                iptList: [],
                userId: null,
                isTeacher: false,
                checkFinalExam: false,
                status: 0,
                commonCourseName: null,
                isShow: false,
                loading: false,
                isLogin: true,
                regex: new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/),
                regexFB: new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/)(www\.)facebook\.com.*$/),
                isAccountTeacher:false,
            };
        },
        created() {
            this.$autoLogin().then(
                () => {
                    this.init();
                    this.isLogin = true;
                },
                async () => {
                    this.isLogin = false;
                    // Danh sách khóa học tạo bởi
                    let importantList = await this.getImportantCourses();

                    // ID: khóa học
                    let courseId = this.$route.query.buyCourseId;

                    let exist = importantList.some(item => item.courseId == courseId);

                    if (!exist) {
                        this.$router.push({
                            path: "/home",
                        });
                    } else {
                        this.init();
                    }
                }
            );
        },
        components: {
            loading            
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                history: (state) => state.header.history,
            })
        },
        methods: {
            init: async function () {
                // Mở loading
                this.loading = true;

                // ID: khóa học
                let courseId = this.$route.query.buyCourseId;
                let category = await this.getCourseCategoryDetail(courseId);
                let result = this.getCurriculum(category.courseCategoryCode);
                let isFinalExam = await this.getFinalExamList(courseId);
                let isExam;
                result.forEach(element => {
                    isExam = element.menuList.filter(item => item.name == 'THI__CUOI__KI' && item.show == true);
                });
                if(isExam.length > 0  && isFinalExam != 0){
                    this.checkFinalExam = true;
                }

                // Thông tin học viên
                let userType = window.sessionStorage.getItem("userType");
                this.isTeacher = userType != null && parseInt(userType) != 2 ? true : false;
                this.userId = window.sessionStorage.getItem("id");

                // Lấy thông tin khóa học
                this.course = await this.getCoursePurchaseDetails(courseId);

                // Check if the account is a teacher
                this.isAccountTeacher = await this.checkAccountTeacher(this.userId, this.course.courseId)

                // Lấy thông tin loại khóa học
                this.course.categoryCode = await this.getCourseCategory(courseId);
                // Tự động cập nhật api . Bắt đầu khóa học đối với những khóa học [13, 14, 15]
                this.beginSpecial(this.course);

                // Lấy danh sách khóa học được tạo bởi quyền cao nhất
                this.iptList = await this.getImportantCourses();

                // Lấy trạng thái của học viên đối với khóa học
                this.status = await this.getExamStatus({courseId: this.course.courseId, studentId: this.userId});

                // 获取已学习同源课名称
                this.commonCourseName = await this.getCommonCourseName({courseId: this.course.courseId, studentId: this.userId});

                // Đóng loading
                this.loading = false;
            },
            
            beginSpecial: async function (course) {
                if ((course.categoryCode == 13 || course.categoryCode == 14 || course.categoryCode == 15) && this.isLogin) {
                    await this.startStudy(course.courseId);
                }
            },


            // Lấy thông tin chi tiết của khóa học
            getCoursePurchaseDetails: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/getCoursePurchaseDetails", {
                            languageType: this.$lang(),
                            courseId: courseId,
                        })
                        .then((response) => {
                            if (!this.regex.test(response.data.courseSynopsis)){
                                response.data.courseSynopsis = response.data.courseSynopsis.replace(/\n/g, '</br>');
                            }
                            let course = {
                                courseId: courseId,
                                category: response.data.courseCategory,
                                cover: response.data.courseCover,
                                language: response.data.courseLanguageName,
                                learnTerm: response.data.courseLearnTerm,
                                price: response.data.coursePrice,
                                name: response.data.courseName,
                                synopsis: response.data.courseSynopsis,
                                snopsisPath: response.data.courseSynopsisPath,
                                type: response.data.courseType,
                                endDate: response.data.endDate,
                                imgPath1: response.data.imgPath1,
                                imgPath2: response.data.imgPath2,
                                imgPath3: response.data.imgPath3,
                                imgPath4: response.data.imgPath4,
                                imgPath5: response.data.imgPath5,
                                covenant: response.data.isCovenant,
                                startDate: response.data.startDate,
                                startStudy: response.data.startStudy,
                                title1: response.data.title1,
                                title2: response.data.title2,
                                title3: response.data.title3,
                                title4: response.data.title4,
                                title5: response.data.title5,
                                content1: response.data.content1,
                                content2: response.data.content2,
                                content3: response.data.content3,
                                content4: response.data.content4,
                                content5: response.data.content5,
                                externalLink: response.data.externalLink,
                                courseType: parseInt(response.data.courseType),
                                examFlag: parseInt(response.data.examFlag)
                            }
                            
                            let result =  this.convertSynopsis(course);
                            resolve(result);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Kiểm tra khóa học live stream
            convertSynopsis: function (course) {

                course["isUrl"] = false;
                course["isUrlFb"] = false;

                if (this.regex.test(course.synopsis)) {

                    course["isUrl"] = true;
                    let url = course.synopsis.split("\r\n");

                    if (this.regexFB.test(course.synopsis)) {
                        course["isUrlFb"] = true;
                        course.synopsis = `<iframe src="${url[1]}" style='border:none;overflow:hidden;width:100%;height:100%' scrolling='no' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share' allowFullScreen='true'></iframe>`;
                    } else {
                        course.synopsis = `<iframe style='width:100%;height:100%' src="${url[1]}" frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>`;
                    }
                }

                return course;
            },

            // Lấy tiến độ khóa học
            getCurriculumInfo: function (courseId) {                
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getCurriculumInfo", {
                        courseId: courseId,
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },

            //  Trạng thái khóa học
            getExamStatus: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getExamStatus", {
                            courseId: params.courseId,
                            studentId: params.studentId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            // 获取已学习同源课名称
            getCommonCourseName: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCommonCourseName", {
                            courseId: params.courseId,
                            studentId: params.studentId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            // Danh sách khóa học được tạo bởi quyền cao nhất
            getImportantCourses: function () {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getImportantCourses", {
                            languageType: this.$lang(),
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Xử lý bắt đầu khóa học
            start: async function () {

                let exist = this.iptList.some(item => item.courseId == this.course.courseId);

                // Đối với những khóa học có status != -1
                if (this.status == -1 && !exist && this.course.courseType == 0) {
                    this.$alert(this.$i18n.t("new.title106"), "", {
                        confirmButtonText: this.$i18n.t("js.confirm"),
                    });
                    return;
                }
                if(this.commonCourseName != null && this.commonCourseName != "" && this.commonCourseName != undefined){
                    this.$confirm(
                        this.$i18n.t("js.commonCourseMessage").replace("{1}",this.commonCourseName).replace("{2}",this.commonCourseName),
                        this.$i18n.t("js.hint"),
                        {
                            confirmButtonText: this.$i18n.t("js.confirm"),
                            cancelButtonText: this.$i18n.t("js.cancel"),
                            cancelButtonClass: "btn-custom-cancel"
                        }
                    )
                    .then(() => {
                        this.begin({courseId: this.course.courseId, name: this.course.name, categoryCode: this.course.categoryCode, type: this.course.courseType, examFlag: this.course.examFlag});
                    })
                    .catch(() => {});
                } else {
                    if (this.status == 0) {
                        // Bắt đầu khóa học
                        this.$confirm(
                            this.$i18n.t("js.beginLearning"),
                            this.$i18n.t("js.hint"),
                            {
                                confirmButtonText: this.$i18n.t("js.confirm"),
                                cancelButtonText: this.$i18n.t("js.cancel"),
                                cancelButtonClass: "btn-custom-cancel"
                            }
                        )
                        .then(() => {
                            this.begin({courseId: this.course.courseId, name: this.course.name, categoryCode: this.course.categoryCode, type: this.course.courseType, examFlag: this.course.examFlag});
                        })
                        .catch(() => {});
                    } else {
                        this.begin({courseId: this.course.courseId, name: this.course.name, categoryCode: this.course.categoryCode, type: this.course.courseType, examFlag: this.course.examFlag});
                    }
                }
            },
            
            // Xem trước khoá học
            preview:  async function ()  {
                this.$router.push({
                    path: "exam/preview",
                    query: {
                        courseId: this.course.courseId,
                        courseName: this.course.name,
                        examFlag: this.course.examFlag,
                    },
                });
            },
            
            // Bắt đầu khóa học
            begin: async function (param) {
                let codeStatus = 0;

                let startStudyInfo = {};
                startStudyInfo = await this.startStudy(param.courseId).catch((error) => {
                    startStudyInfo.code = -1;
                });
                codeStatus = startStudyInfo.code;

                // Kiểm tra trạng thái khóa học
                if (codeStatus == -1) {
                    this.$message.warning(this.$i18n.t("codeStatus.code_1_99"));
                    return;
                }

                if (codeStatus == 1) {
                    this.$message.warning(this.$i18n.t("codeStatus.code_1_1"));
                    return;
                }

                if (codeStatus == 2) {
                    this.$message.warning(this.$i18n.t("codeStatus.code_1_2"));
                    return;
                }
                
                if (codeStatus == 3) {
                    this.$message.warning(this.$i18n.t("codeStatus.code_1_3").replace("{0}",startStudyInfo.courseName));
                    return;
                }

                if (codeStatus == 4) {
                    this.$message.warning(this.$i18n.t("codeStatus.code_1_4"));
                    return;
                }

                if (codeStatus == 0) {
                    this.jumpLesson({courseId: param.courseId, name: param.name, categoryCode: param.categoryCode, type: param.type, examFlag: param.examFlag});
                }
            },

            //  Gọi api bắt đầu khóa học
            startStudy: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/startStudy", {
                            courseId: courseId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            
            getInfoFinalCourse: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/getExamQuestionsByCourseId", {
                            courseId: courseId,
                        })
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            getsingleCoursePeriodDate: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getsingleCoursePeriodDate", {
                            courseId: courseId,
                        })
                        .then((response) => {
                            resolve(Number(response.data.num));
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            
            updatecourseFinished: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/updatecourseFinished", {
                            courseId: params.courseId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Xử lý mở bảng khảo sát
            startBks: async function (param) {

                if (parseInt(param.categoryCode) == 13 || parseInt(param.categoryCode) == 15) {
                    let curriculumInfo = await this.getCurriculumInfo(this.course.courseId);

                    // Vui lòng gửi cam kết trước khi khảo sát.
                    if (curriculumInfo.isShowStep5 != 1) {
                        this.$message.warning(window.vm.$i18n.t("new.title46"));
                        return;
                    }

                    if (curriculumInfo.isShowStep1 == 1 && curriculumInfo.isShowStep2 == 1 && curriculumInfo.isShowStep3 == 1 && curriculumInfo.isShowStep5 == 1) {
                        
                        this.beginBks({courseId: param.courseId, name: param.nam});
                    }
                    
                    return;
                }

                if (parseInt(param.categoryCode) == 14) {
                    window.open(param.externalLink);
                    return;
                }

                if (parseInt(param.categoryCode) == 16) {
                    let status = await this.updatecourseFinished(param);
                    window.open(param.externalLink);
                    return;
                }
            },

            // Mở bảng khảo sát
            beginBks: function (params) {
                this.$router.push({
                    path: "exam/covenant",
                    query: {
                        prev: "AICOURSE",
                        courseId: params.courseId,
                        courseName: params.name,
                        templateType: 1,
                        type: 1,
                    },
                });
            },

            //  Mở bảng cảm kết
            startBck: function (param) {
                this.$router.push({
                    path: "exam/covenant",
                    query: {
                        prev: "AICOURSE",
                        courseId: param.courseId,
                        courseName: param.name,
                        templateType: 0,
                        type: 2,
                    },
                });
            },

            // Lấy thông tin loại khóa học
            getCourseCategory: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseCategory", {
                            courseId: courseId,
                        })
                        .then((response) => {
                            resolve(response.data.courseCategoryCode);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            // Lấy ra danh sách bài thi cuối kỳ
            getFinalExamList: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getFinalExamList", {
                            courseId: data
                        })
                        .then((response) => {
                            resolve(response.data || []);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            getCourseCategoryDetail: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getCourseCategory", {
                        courseId: courseId,
                    })
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch((err) => {reject(err.response)});
                });
            },

            // Cập nhập thời gian bắt đầu học
            updateStudyTime: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/updateStudyTime", {
                            courseId: params.courseId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Đi đến trang mục lục
            jumpLesson: async function (param) {
                let outlineInfo = {
                    courseId: param.courseId,
                    courseName: param.name,
                    examFlag: param.examFlag,
                    type: param.type,
                    categoryCode: param.categoryCode
                };
                if(this.course.categoryCode == 9 || this.course.categoryCode == 10 || this.course.categoryCode == 11 || this.course.categoryCode == 12){
                    this.$router.push({
                        path: "curriculumExam",
                        query: {
                            outlineInfo: JSON.stringify(outlineInfo),
                            courseType: param.type
                        },
                    });
                } else {
                    this.$router.push({
                        path: "curriculum",
                        query: {
                            outlineInfo: JSON.stringify(outlineInfo),
                            courseType: param.type
                        },
                    });
                }
            },
            
            // Xác nhận tiến độ
            progess: function (param) {
                this.$router.push({
                    path: "learnProgressList",
                    query: {
                        courseId: param.courseId,
                        userId: param.userId,
                        courseName: param.name,
                    },
                });
            },

            // Quay lại
            back: function () {
                if (this.checkGeneralEnvironment() == 4 || this.checkGeneralEnvironment() == 0) {
                    if (this.history == '/home/search') {
                        this.$router.go(-1);
                    }
                    let routeName = this.history == null ? "/home/SchoolBusiness_new" : this.history;
                    this.$router.push(routeName);
                } else {
                    let routeName = this.history == null ? "/home/SchoolBusiness_new" : this.history;
                    this.$router.push(routeName);
                }
            },

            // Độ rộng của cpn tiến độ
            setDialogWidth: function () {
                let val = document.body.clientWidth;
                const def = 1024;
                if (val < def) {
                    this.dialogWidth = "90%";
                } else {
                    this.dialogWidth = "40%";
                }

                return this.dialogWidth;
            },

            // Kết thúc khóa học
            finished: async function () {
                let exist = this.iptList.some(item => item.courseId == this.course.courseId);

                // Đối với những khóa học có status != -1
                if (this.status == -1 && !exist ) {
                    this.$alert(this.$i18n.t("new.title107"), "", {
                        confirmButtonText: this.$i18n.t("js.confirm"),
                    });
                    return;
                }

                // Lấy thông tin tiến độ khóa học
                this.curriculumInfo = await this.getCurriculumInfo(this.course.courseId);

                // Mở cpn kết thúc khóa học
                this.isShow = true;
            },

            // Kết thúc
            submitFinishCourse: function () {
                this.$confirm(this.$i18n.t("new.title35"), this.$i18n.t("js.hint"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$i18n.t("js.confirm"),
                    cancelButtonText: this.$i18n.t("js.cancel"),
                    cancelButtonClass: "btn-custom-cancel",
                }).then(async () => {
                    await this.updatecourseFinished(this.course);
                    this.isShow = false;
                });
            },
            checkAccountTeacher: function (userId, courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                      .post("/courseStudy/checkAccountTeacher",{
                        userId: userId,
                        courseId: courseId
                      })
                    .then(response => {
                      resolve(response.data);
                      if (response.data) {
                        this.isAccountTeacher = true;
                      }
                    })
                    .catch(err => {
                      reject(err);
                    });
                });
            }
        },
    };
</script>
<style scoped>
    .primarylists.list-mosbile .titles.clear {
        left: 48px;
        padding-left: 2px;
    }
    .three-btn-mobile {
        display: block !important;
    }
    .three-btn-mobile .btn-01 {
        margin-top: 10px !important;
    }
    .btn-01.btn-back {
        margin-top: 0 !important;
    }
    .lkt-livestream {
        max-width: 1180px;
        height: 640px;
        min-height: 300px;
    }
    @media (max-width: 760px) {
        .lkt-livestream {
            height: 460px;
        }
    }
    @media (max-width: 480px) {
        .lkt-livestream {
            height: 300px;
        }
    }
    /* header */
    .Aicourse_header {
        max-width: 1180px;
        min-width: 480px;
        width: calc(100% - 40px);
        margin: 0 auto;
        background-image: url(../../../static/images/bg/aicourse_bg1.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        /*height: 570px;*/
        margin-bottom: 30px;
    }

    .Aicourse_header_black {
        background-color: rgba(0, 0, 0, 0.6);
        padding: 25px;
        border-radius: 10px;
        /*height: 520px;*/
        padding-top: 15px;
    }

    .Aicourse_header_top {
        text-align: left;
        color: #fafafa;
        letter-spacing: 1px;
        margin-bottom: 50px;
        font-weight: 400;
    }

    .Aicourse_header_top p {
        text-align: left;
        color: #fafafa;
        letter-spacing: 1px;
        font-weight: 400;
    }

    .Aicourse_header_top .artificialIntelligence p {
        font-family: Artifical;
    }

    .Aicourse_header_top .HorizontalLine {
        width: 30px;
        height: 1px;
        background-color: #30d5c8;
        border-radius: 20px;
        margin-top: 5px;
    }

    .Aicourse_header_top .HorizontalLine1 {
        background-color: rgb(255, 112, 66);
    }

    .Aicourse_header_inner {
        text-align: center;
        font-family: Arial;
        /*width: 490px;*/
        margin: 0 auto;
    }

    .Aicourse_header_inner p:nth-child(1) {
        font-size: 48px;
        letter-spacing: 1px;
        color: #fafafa;
        font-family: Arial;
        font-weight: 400;
        margin-bottom: 30px;
    }

    .Aicourse_header_inner p:nth-child(2) {
        font-size: 14px;
        letter-spacing: 1px;
        color: #e8e6e6;
        /* font-family: lato-light, lato, sans-serif;
  font-weight: 400; */
        font-family: Arial;
        font-weight: 200;
        font-style: normal;
        margin-bottom: 40px;
        line-height: 17px;
    }

    .Aicourse_header_inner button {
        line-height: 20px;
        padding: 6px 35px;
        font-size: 13px;
        color: #fafafa;
        font-family: Arial;
        font-weight: 400;
        background-color: unset;
        border-radius: 20px;
        border: 2px #fff solid;
        margin-bottom: 10px;
        margin-top: 20px;
        transition: 0.5s ease;
    }

    .Aicourse_header_inner button:hover {
        color: #ffffff;
        border: 2px #fafafa solid;
        transition: 0.5s ease;
    }

    .Aicourse_header_inner_img {
        margin: 0 auto;
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
        background: url(../../assets/Aicourse/icon_play.png) no-repeat;
        background-size: cover;
        transition: 0.5s ease-in-out;
    }
    .Aicourse_header_inner_img:hover {
        cursor: pointer;
        background: url(../../assets/Aicourse/icon_play_hover.png) no-repeat;
        background-size: cover;
        transition: 0.5s ease-in-out;
    }

    /* 	.Aicourse_header_inner_img img {
  width: 40px;
  height: 40px;
} */

    .Aicourse_header_inner p:nth-child(5) {
        font-size: 12px;
        letter-spacing: 1px;
        color: rgb(255, 255, 255);
        margin-bottom: 30px;
        text-align: center;
    }

    /* .Aicourse_box .Aicourse_box_top p:nth-child(5) {
  margin-top: 30px;
  padding: 10px;
  font-size: 18px;
  color: #565656;
  font-family: myFont;
  text-align: left;
} */
    .Aicourse_header_inner button:hover {
        background-color: #fff;
        color: #333;
        transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
    }

    /*table*/
    .Aicourse_table {
        max-width: 1180px;
        min-width: 480px;
        width: calc(100% - 60px);
        margin: 0 auto;
    }

    .Aicourse_table ul {
        list-style: none;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    .Aicourse_table ul > li {
        display: inline-block;
        padding: 10px 0 10px 40px;
        border-left: 1px solid rgba(199, 199, 199, 1);
        /* font-family: museo-slab-w01-100, serif; */
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
    }

    .Aicourse_table ul > li span {
        font-family: lato, sans-serif;
        font-weight: 300;
        font-style: normal;
    }

    .Aicourse_table ul > li:first-child {
        border-left: none !important;
    }

    .Aicourse_table ul > li p:nth-child(1) {
        font-size: 14px;
        color: rgb(153, 153, 151);
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 400; */
        margin-bottom: 15px;
    }

    .Aicourse_table ul > li p:nth-child(2) {
        font-size: 18px;
        color: #414141;
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 700; */
        margin-bottom: 5px;
    }

    .Aicourse_table ul > li p:nth-child(3) {
        font-size: 11px;
        color: rgb(153, 153, 151);
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 400; */
    }

    /* ----- */
    .Aicourse_font_right {
        width: 207px;
        height: 215px;
        float: right;
        border: 0px solid rgba(153, 153, 151, 1);
        background-color: rgba(250, 250, 250, 1);
        border-radius: 15px 15px 15px 15px;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
        padding: 20px;
        /*font-family: Artifical-slideshow;*/
        text-align: center;
        margin-top: 100px;
        margin-right: 6px;
    }

    .Aicourse_font_right p:nth-child(1) {
        margin: 0 auto;
        width: 80px;
        margin-top: 10px;
    }

    .Aicourse_font_right p:nth-child(1) img {
        width: 78px;
        height: 48px;
    }

    .Aicourse_font_right p:nth-child(2) {
        margin: 0 auto;
        font-size: 25px;
        color: #414141;
        /*font-family: lato-light, lato, sans-serif;*/
        font-weight: 400;
        margin-top: 20px;
    }

    .Aicourse_font_right p:nth-child(2) > span {
        font-weight: bold;
        font-size: 25px;
        color: #414141 !important;
        /*font-family: lato-light, lato, sans-serif;*/
    }

    .Aicourse_box .Aicourse_box_top p:first-child {
        font-size: 28px;
        color: #565656;
        font-family: myFont;
    }

    .Aicourse_box .Aicourse_box_top p:nth-child(2) {
        width: 280px;
        margin: 0 auto;
        font-size: 40px;
        color: #323232;
        font-family: myFont2;
        text-align: center;
    }

    .Aicourse_box .Aicourse_box_top p:nth-child(2) span {
        display: flex;
        width: 60px;
        height: 4px;
        float: right;
        margin-top: -4px;
        margin-right: 6px;
        background-color: #e91926;
    }

    .Aicourse_list {
        max-width: 1100px;
        min-width: 480px;
        margin: 0 auto;
    }

    .Aicourse_Top {
        width: 100%;
        height: 44px;
        background-color: #323232;
        margin-bottom: 40px;
    }

    .Aicourse_list ul {
        max-width: calc(100% - 60px);
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        zoom: 1;
    }

    .Aicourse_list ul li {
        width: 100%;
        height: 317px;
        margin-top: 50px;
        margin-bottom: 100px;
    }

    .Aicourse_list ul li .Aicourse_font {
        width: 50%;
        position: absolute;
    }

    .Aicourse_list ul li .Aicourse_font2 {
        width: 40%;
        position: absolute;
    }

    .Aicourse_list ul li:nth-child(2n + 1) .Aicourse_font2 {
        float: right;
        position: unset;
    }

    .Aicourse_list ul li .Aicourse_font p:first-child {
        margin-top: 50px;
        font-size: 25px;
        /*font-family: dinneuzeitgroteskltw01-_812426, sans-serif;*/
        color: rgb(70, 70, 70);
        font-weight: bold;
    }

    .Aicourse_list ul li .Aicourse_font p:first-child span {
        display: flex;
        width: 52px;
        height: 3px;
        float: left;
        position: absolute;
        margin-top: 49px;
        background-color: #e91926;
    }

    .Aicourse_firsli_span {
        background-color: rgb(48, 213, 200) !important;
        margin-top: 60px !important;
    }

    .Aicourse_list ul li .Aicourse_font p:nth-child(2) {
        width: 100%;
        margin-top: 32px;
        font-size: 15px;
        /*font-family: lato-light, lato, sans-serif;*/
        color: #414141;
        font-weight: 400;
        text-align: justify;
    }

    .Aicourse_firsli_p2 {
        width: 540px;
    }

    .Aicourse_list ul li .Aicourse_img {
        float: right;
        max-width: 60%;
        height: 317px;
        display: flex;
        align-items: center;
    }

    .Aicourse_list ul li .Aicourse_img img {
        height: calc(100vw * 0.28);
        max-height: 317px;
        max-width: 100%;
    }

    .Aicourse_list ul li:nth-child(2n) .Aicourse_font {
        float: right;
    }

    .Aicourse_list ul li:nth-child(2n-1) .Aicourse_img {
        position: absolute;
    }

    .Aicourse_blackp {
        max-width: 1024px;
        min-width: 480x;
        width: calc(100% - 100px);
        margin: 0 auto;
        padding-top: 50px;
    }

    .Aicourse_blackp_first {
        font-size: 40px;
        color: rgb(65, 65, 65);
        text-align: left;
        /*font-family: lato-light, lato, sans-serif;*/
        font-weight: 400;
    }

    .Aicourse_blackp_two {
        font-size: 45px;
        color: rgb(70, 70, 70);
        text-align: center;
        /*font-family: dinneuzeitgroteskltw01-_812426, sans-serif;*/
        margin-top: 200px;
        margin-bottom: 200px;
        font-weight: 700;
    }

    /* last*/
    .ArtificialIntelligence_last {
        width: 100%;
        height: auto;
        min-height: 290px;
        background-image: url(../../assets/index/bg_1.png);
        background-position: 50%;
        /* background-position: center center; */
        background-size: cover;
        position: relative;
        margin-top: 50px;
        background-attachment: fixed;
        /*margin-bottom: 10px;*/
    }

    .ArtificialIntelligence_last-div {
        height: auto;
        min-height: 290px;
        width: 100%;
        padding-top: 80px;
        color: #fafafa;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.65);
        padding-bottom: 2px;
    }

    .ArtificialIntelligence_last h1 {
        /*font-family: jura, sans-serif;*/
        font-size: 20px;
        color: #fafafa;
        font-weight: 400;
        line-height: 24px;
    }

    .ArtificialIntelligence_last-h1 {
        margin-bottom: 50px;
    }

    .ArtificialIntelligence_last p {
        margin-bottom: 10px;
        /*font-family: dinneuzeitgroteskltw01-_812426, sans-serif;*/
        font-size: 60px;
        color: #fafafa;
        font-weight: 700;
    }

    .ArtificialIntelligence_last button {
        line-height: 20px;
        padding: 6px 35px;
        font-size: 13px;
        color: #fff;
        /*font-family: Arial, Helvetica, sans-serif;*/
        background-color: unset;
        border-radius: 20px;
        border: 2px #fff solid;
        transition: 0.5s ease;
    }

    .ArtificialIntelligence_last button:hover {
        background-color: #fff;
        color: #333;
        /* transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s; */
        transition: 0.5s ease;
    }

    .ArtificialIntelligence-figure_text {
        /*height: 76px;*/
        /*width: 755px;*/
        font-family: Arial;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
    }

    .Aicourse_header_inner_lastp {
        color: rgb(250, 250, 250);
        font-size: 12px;
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 400; */
        /*font-family: source-han-sans-simplified-c, sans-serif;*/
        font-weight: 200;
        font-style: normal;
        letter-spacing: 0.050000001986821495em;
    }

    .Aicourse_font_p {
        /*width: 300px !important;*/
        color: #414141 !important;
        font-size: 18px !important;
        /*font-family: jura, sans-serif !important;*/
        font-weight: 400 !important;
        text-align: unset !important;
    }

    .Aicourse_list ul li .Aicourse_font2 p:first-child {
        text-indent: 4px;
    }
    .primarylists .titles .title {
        text-transform: none !important;
    }
    .btn-finish-aircourse {
        text-align: center;
        margin-left: 275px;
    }
    .btn-finish-aircourse .SubmitPaper_pn {
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 20px;
        cursor: pointer;
    }
    @media (max-width: 480px) {
        .btn-finish-aircourse {
            text-align: center;
            margin-left: 95px !important;
        }
    }
</style>
<style>
    .btn-custom-cancel {
        float: right;
        margin-left: 10px;
        margin-top: 2px;
    }
</style>




// WEBPACK FOOTER //
// src/views/Aicourse/Aicourse.vue